import { useCallback, useEffect, useMemo, useState } from "react";
import { UseTokenPagination } from "../Table.types";

const useTokenPagination = (
  pageNumber = 1,
  baseMapping = {}
): UseTokenPagination => {
  const [mapping, setMapping] = useState<{ [key: number]: string }>(
    baseMapping
  );

  const getMapping = useCallback(() => {
    return mapping;
  }, [mapping]);

  const updateToken = useCallback(
    (nextToken: string) => {
      setMapping((m) => ({
        ...m,
        [pageNumber + 1]: nextToken,
      }));
    },
    [pageNumber]
  );

  const useUpdateToken = useCallback(
    function useUpdateToken(nextToken: string) {
      useEffect(() => updateToken(nextToken), [nextToken]);
    },
    [updateToken]
  );

  const clearPagination = useCallback(() => {
    setMapping({});
  }, []);

  return useMemo(
    () => ({
      currentToken: mapping[pageNumber],
      useUpdateToken,
      updateToken,
      hasToken: (pageNumber: number) => pageNumber in mapping,
      getMapping,
      clearPagination,
    }),
    [
      mapping,
      pageNumber,
      updateToken,
      useUpdateToken,
      getMapping,
      clearPagination,
    ]
  );
};

export { useTokenPagination };
